import validator from "validator";
import { parseStringValue } from "../parse-string-value.js";
const { isEmail, normalizeEmail } = validator;
export function emailField(opts) {
    return (value) => {
        const res = parseStringValue(value, opts);
        if (!res.isValid || !res.value)
            return res;
        if (!isEmail(res.value)) {
            return {
                isValid: false,
                error: opts.message,
            };
        }
        return {
            isValid: true,
            value: normalizeEmail(res.value),
        };
    };
}
